import { useEffect, useRef } from "react";
import { allowedMarketingPage, marketingHashForPage, marketingPageForHash } from "./marketing-navigation";

export function useMarketingNavigation(page: string, setPage: (page: string) => void, allowedKeys: string[], enabled: boolean) {
  const previous = useRef(page);
  const scope = allowedKeys.join("|");
  useEffect(() => {
    if (!enabled) return;
    const restore = () => {
      const target = marketingPageForHash(window.location.hash);
      if (target && allowedMarketingPage(target, allowedKeys)) setPage(target);
      else if (target) {
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
        setPage("dashboard");
      } else if (marketingHashForPage(previous.current)) setPage("dashboard");
    };
    restore();
    window.addEventListener("popstate", restore);
    window.addEventListener("hashchange", restore);
    return () => {
      window.removeEventListener("popstate", restore);
      window.removeEventListener("hashchange", restore);
    };
  }, [enabled, scope, setPage]);

  useEffect(() => {
    if (!enabled) return;
    const hash = allowedMarketingPage(page, allowedKeys) ? marketingHashForPage(page) : null;
    const base = window.location.pathname + window.location.search;
    if (hash && window.location.hash !== hash) window.history.pushState(null, "", base + hash);
    else if (!hash && marketingHashForPage(previous.current) && marketingPageForHash(window.location.hash)) window.history.pushState(null, "", base);
    previous.current = page;
  }, [page, enabled, scope]);
}
